/**
 * Animate navigation based on scroll position using Intersection Observer
 */
export function animateNavigationOnScroll(onSectionChange?: (sectionId: string) => void): void {
  const sections = document.querySelectorAll('[data-section]');
  const navLinks = document.querySelectorAll('[data-nav-link]');
  let currentSection = '';
  
  // Create a map to store intersection ratios
  const sectionRatios = new Map();
  
  // Create the observer
  const observer = new IntersectionObserver((entries) => {
    // Update intersection ratios for each section
    entries.forEach(entry => {
      sectionRatios.set(entry.target.id, entry.intersectionRatio);
    });
    
    // Find section with highest visibility ratio
    let maxRatio = 0;
    let maxSection = '';
    
    sectionRatios.forEach((ratio, sectionId) => {
      if (ratio > maxRatio) {
        maxRatio = ratio;
        maxSection = sectionId;
      }
    });
    
    // Special case: check if we're at the bottom of the page
    const scrollHeight = document.documentElement.scrollHeight;
    const scrollPosition = window.scrollY + window.innerHeight;
    const isAtBottom = Math.abs(scrollHeight - scrollPosition) < 20;
    
    if (isAtBottom && sections.length > 0) {
      const lastSection = sections[sections.length - 1];
      if(!lastSection) return;

      maxSection = lastSection.id;
    }
    
    // Activate the nav link for the most visible section
    if (maxSection) {
      const activeNavLink = document.querySelector(`[data-nav-link="${maxSection}"]`);
      const inactiveNavLinks = document.querySelectorAll(`[data-nav-link]:not([data-nav-link="${maxSection}"])`);
      if (activeNavLink) {
        activeNavLink.classList.add('active');
      }
      inactiveNavLinks.forEach(link => link.classList.remove('active'));

      if (maxSection !== currentSection) {
        currentSection = maxSection;
        onSectionChange?.(maxSection);
      }
    }
  }, {
    // Options for the observer
    threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
    rootMargin: "0px 0px -10% 0px"  // Slight offset from bottom
  });
  
  // Observe all sections
  sections.forEach(section => {
    // Initialize all sections with zero ratio
    sectionRatios.set(section.id, 0);
    observer.observe(section);
  });
}